import { UploadContent } from 'xsmodules/remote-control/services/file-manager.service';

export class FileData {
  public fileName = '';
  public fullPath = '';
  public fileSize = '';
  public date: Date = null;
  public formattedDate = '';

  public static clone = (data: FileData): FileData => {
    const copy = new FileData();
    copy.fileName = data.fileName;
    copy.fullPath = data.fullPath;
    copy.fileSize = data.fileSize;
    if (data.date) {
      copy.date = new Date(data.date);
    }
    copy.formattedDate = data.formattedDate;
    return copy;
  };
}

export interface IFileActionProgress {
  file: File;
  actionType: ActionType;
  progress?: number;
  location?: string;
  error?: string;
  contentStatus?: ContentStatus;
  timeOfCompletion?: Date;
  isCancellation?: boolean;
  compressRequestId?: number;
}

export interface IFileManagerActionItem {
  actionType: ActionType;
  content: UploadContent[];
  fileName: string;
  filePath: string;
  file?: File;
}

export interface IFileInfo {
  fileName: string;
  filePath: string;
}

export enum ActionType {
  Upload,
  Download,
  Compress,
  Decompress,
}

export enum ContentStatus {
  InProgress,
  Done,
  Failed,
  AwaitFeedback,
  CompressInProgress,
}
